module.exports = __webpack_public_path__ + "img/google.138a9b65.png";